import cn from 'classnames'
import React, { forwardRef, useRef } from 'react'
import type { FC } from 'react'
import mergeRefs from 'react-merge-refs'
import { LoadingDots, Link } from 'components/ui'
import s from './button.module.css'
import { ButtonProps } from './types'

const Button: FC<ButtonProps> = forwardRef((props, buttonRef) => {
  const {
    className,
    variant = 'primary',
    children,
    active,
    width,
    loading = false,
    disabled = false,
    style = {},
    Component = 'button',
    href,
    ...rest
  } = props
  const ref = useRef<typeof Component>(null)

  const rootClassName = cn(
    s.root,
    {
      [s.primary]: variant === 'primary',
      [s.secondary]: variant === 'secondary',
      [s.link]: variant === 'link',
      [s.ghost]: variant === 'ghost',
      [s.text]: variant === 'text',
      [s.loading]: loading,
      [s.disabled]: disabled,
    },
    className,
  )

  if (href) {
    return (
      <Link
        href={href}
        passHref
        className={rootClassName}
        style={{
          width,
          ...style,
        }}
        {...rest}
      >
        {children}
        {loading && <LoadingDots />}
      </Link>
    )
  }

  return (
    <Component
      aria-pressed={active}
      data-variant={variant}
      ref={mergeRefs([ref, buttonRef])}
      className={rootClassName}
      disabled={disabled}
      style={{
        width,
        ...style,
      }}
      {...rest}
    >
      {children}
      {loading && <LoadingDots />}
    </Component>
  )
})

export default Button
